import styled from 'styled-components';

import { media } from 'shared/helpers/styling/styling';

export const StyledShipmentFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${media.largeTablet`
justify-content: center;
`}
  ${media.tablet`
justify-content: center;
`}
${media.phone`
flex-direction: column;
align-items: center;
`}
`;

export const StyledShipmentFiltersItem = styled.div`
  width: 540px;
  ${media.phone`
width: 250px;
`}
`;
